var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"chart-container"},[_c('canvas',{ref:"canvas",staticClass:"gaugeCanvas",attrs:{"id":_vm.chartName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }